var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'background-color' : _vm.getBackgroundColor(), 'color' : _vm.getTextColor(), 'font-family' : _vm.font })},[_vm._v(" "+_vm._s(_vm.special_tag_for_item)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }